import { styled } from "@mui/material/styles";

export const Container = styled("div", {
  label: "offer-bc-body",
})`
  margin: ${({ theme }) => theme.spacing(2, 4, 2)};

  ${({ theme }) => theme.breakpoints.up("md")} {
    margin: ${({ theme }) => theme.spacing(4, 0, 4)};
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    margin-bottom: ${({ theme }) => theme.spacing(10)};
  }

  ::before {
    ${({ theme }) => theme.breakpoints.up("md")} {
      content: "";
      display: block;
      margin: ${({ theme }) => theme.spacing(0, -4)};
    }

    ${({ theme }) => theme.breakpoints.up("lg")} {
      margin-right: ${({ theme }) => theme.spacing(-10)};
      margin-left: ${({ theme }) => theme.spacing(-10)};
    }
  }
`;

export const SectionsWrapper = styled("div", {
  label: "sections-wrapper",
})`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2.5)};
  width: 100%; 
  ${({ theme }) => theme.breakpoints.up("md")} {
    justify-content: space-between; 
`;

export const Section = styled("div", {
  label: "offer-section",
})`
  padding: 0;
  min-width: 0;

  ${({ theme }) => theme.breakpoints.up("md")} {
    &:first-of-type {
      flex: 6;
    }

    &:last-of-type {
      flex: 4;
    }
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 100%;
    padding: 0;
  }
`;
